import { render, staticRenderFns } from "./PromotionSlider.vue?vue&type=template&id=6075ff30&scoped=true&"
import script from "./PromotionSlider.vue?vue&type=script&async=true&lang=js&"
export * from "./PromotionSlider.vue?vue&type=script&async=true&lang=js&"
import style0 from "./PromotionSlider.vue?vue&type=style&index=0&id=6075ff30&lang=scss&scoped=true&"
import style1 from "./PromotionSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6075ff30",
  null
  
)

export default component.exports